/**
 * Camp Chef dialog — opens from recipes browse header.
 */
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { HelpMeCookPanel } from './HelpMeCookPanel';

export function HelpMeCookModal({ show, onHide }) {
  const navigate = useNavigate();

  const handleOpenRecipe = (recipeId) => {
    onHide();
    navigate(`/camp-essentials/recipes/${recipeId}`);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="camp-chef-modal"
      contentClassName="camp-chef-modal__content"
      data-testid="camp-chef-modal"
    >
      <Modal.Body className="camp-chef-modal__body p-0">
        <HelpMeCookPanel onClose={onHide} onOpenRecipe={handleOpenRecipe} />
      </Modal.Body>
    </Modal>
  );
}
